// api additions for the new pages
import { api } from './api';

export async function getSchoolsList(payload = {}) {
  const { data } = await api.post('/schools/list', payload);
  return data;
}

export async function getAlertsList(payload = {}) {
  const { data } = await api.post('/alerts/list', payload);
  return data;
}

// ── Supply / Deliveries ──────────────────────────────────────────────
export async function getSupplyData(filters = {}) {
  const { data } = await api.post('/supply/data', filters);
  return data;
}

export async function getSupplyRows(payload = {}) {
  const { data } = await api.post('/supply/rows', payload);
  return data;
}

export async function getSupplyVersion() {
  const { data } = await api.get('/supply/version');
  return data;
}

export async function getHomeSummary() {
  const { data } = await api.get('/home/summary');
  return data;
}

export function supplyExcelExportUrl() {
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/supply/export/excel`;
}

